import React, { Component } from "react";

export default class Ivy extends Component {
  render() {
    return (
          <>
          <h1>It's..... Ivy Lim!</h1>
            <h1>Easily Distracted work-a-holic | Impulsive Web Surfer</h1>
            <ul>
              <li>Interests, Curiosities, Motivations & Passions</li>
              <li>I like rock climbing, video games, traveling, and FOOOD!</li>
              <li>I enjoy problem solving and learning new things.</li>
              <li>Animals and nature are my passions.</li>
              <li>Quirk: Office advocate, but we still love them!</li>

              <img src="/img/ivy1.svg" alt="" />
              <img src="/img/ivy2.svg" alt="" />
              <img src="/img/ivy3.svg" alt="" />
              <img src="/img/ivy4.svg" alt="" />
            </ul>
        </>

    );
  }
}
